// Where every rider starts: nothing about them yet. Each part fills in from onboarding, Settings
// and the rider's own connections; nothing here is anyone's real data.
import type { State } from "../lib/types.ts";

export const emptyState = (): State => ({
  updated: new Date(0).toISOString(),
  ramp: [],
  rampStatus: "draft",
  plan: [],
  routes: [],
  rides: [],
  stages: [],
  coach: null,
  weight: [],
  log: { feel: {}, ready: {} },
  settings: { latestFinish: "21:30", bufferMin: 20, keptEvenings: [], morningFinishBy: "08:45" },
});

/** Before a rider has set where they ride from, sunrise, sunset and the forecast fall back to
 * Greenwich, and the screens say so. Onboarding asks for home before anything is planned. */
export const UNSET_HOME = { lat: 51.4779, lon: -0.0015 };
export const homeOf = (s: { settings: { home?: { lat: number; lon: number } } }): { lat: number; lon: number } => s.settings.home ?? UNSET_HOME;
